import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/template/redux/actions';
import * as commonActions from '../../../features/common/redux/actions';
import * as pluginActions from '../../../features/plugin/redux/actions';
import SmsTemplateForm from './SmsTemplateForm';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ParentDocCard from '../../common/ParentDocCard';
import { TemplateHeaderNav } from '../TemplateHeaderNav';
import { SMS_TEMPLATE } from 'drapcode-constant';
export class SmsTemplateEdit extends Component {
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount = () => {
    const { actions, match, pluginActions } = this.props;
    const { projectId, templateId, version } = match.params;
    const args = {
      projectId: projectId,
      version,
      templateId: templateId,
    };
    actions.loadCollections({ projectId, version });
    actions.fetchTemplate(args);
    pluginActions.loadAllInstalledPlugin({ projectId, version });
  };

  handleSubmit = (values) => {
    const { projectId, templateId, version } = this.props.match.params;
    let args = {
      projectId: projectId,
      templateId: templateId,
      version,
      values: values,
    };
    this.props.actions.updateTemplate(args);
  };

  toggle = (activeTab) => {
    const { projectId, version } = this.props.match.params;
    this.props.history.push({
      pathname: `/2.0/template/${version}/v/${projectId}`,
      state: { activeTab: activeTab },
    });
  };

  showEditForm = () => {
    const { collections, updateTemplatePending } = this.props.template;
    const { templateId, projectId, version } = this.props.match.params;
    const { projectDetail, actions } = this.props;
    if (this.props.template.template) {
      return (
        <SmsTemplateForm
          handleSubmit={this.handleSubmit}
          collections={collections}
          template={this.props.template.template}
          templateId={templateId}
          updateTemplatePending={updateTemplatePending}
          projectDetail={projectDetail}
          version={version}
          actions={actions}
          projectId={projectId}
        />
      );
    }
  };

  render() {
    const { plugin } = this.props;
    const { installedPlugins } = plugin;
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <TemplateHeaderNav
              activeTab={SMS_TEMPLATE}
              title={'SMS Templates'}
              toggle={this.toggle}
              installedPlugins={installedPlugins}
            />
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-dark-blue"
                  >
                    <i className={`wb ${drapcodeIcon(SMS_TEMPLATE)}`}></i>
                  </div>
                  <div className="card-content">{this.showEditForm()}</div>
                </div>
              </div>
              <ParentDocCard>
                <h5>
                  <b> Sms Template Edit</b>
                </h5>
                <p>You can modify the custom sms template as wish you want</p>
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template,
    plugin: state.plugin,
    projectDetail: state.common.projectDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SmsTemplateEdit);
